import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillGlobeWithBg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M5.02259 7.37655L11.2366 3.86039C12.1764 3.3286 13.3295 3.34293 14.2558 3.89791L20.0418 7.36447C20.9464 7.90641 21.5 8.88346 21.5 9.93794V16.4077C21.5 17.5316 20.8718 18.5613 19.8723 19.0754L13.6553 22.2735C12.7718 22.7279 11.7205 22.7155 10.848 22.2403L5.06505 19.0905C4.10037 18.5651 3.5 17.5544 3.5 16.456V9.98754C3.5 8.90644 4.08168 7.90896 5.02259 7.37655Z"
      fill="var(--themis-insight-icon-muted, #D9D9D9)"
    />
    <rect width="32" height="32" rx="13" fill="var(--themis-insight-icon-bg, #2F354A)" />
    <path
      d="M12.7364 22.1814C12.7139 22.1814 12.6839 22.1964 12.6614 22.1964C11.2064 21.4764 10.0214 20.2839 9.29395 18.8289C9.29395 18.8064 9.30895 18.7764 9.30895 18.7539C10.2239 19.0239 11.1689 19.2264 12.1064 19.3839C12.2714 20.3289 12.4664 21.2664 12.7364 22.1814Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
    <path
      d="M22.7043 18.8364C21.9618 20.3289 20.7243 21.5364 19.2168 22.2639C19.5018 21.3114 19.7418 20.3514 19.8993 19.3839C20.8443 19.2264 21.7743 19.0239 22.6893 18.7539C22.6818 18.7839 22.7043 18.8139 22.7043 18.8364Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
    <path
      d="M22.7643 12.2818C21.8193 11.9968 20.8668 11.7644 19.8993 11.5994C19.7418 10.6319 19.5093 9.67187 19.2168 8.73438C20.7693 9.47687 22.0218 10.7294 22.7643 12.2818Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
    <path
      d="M12.7378 8.81547C12.4678 9.73046 12.2728 10.6605 12.1153 11.6054C11.1478 11.7554 10.1878 11.9954 9.23535 12.2804C9.96285 10.773 11.1703 9.53546 12.6628 8.79297C12.6853 8.79297 12.7153 8.81547 12.7378 8.81547Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
    <path
      d="M18.6187 11.4425C16.8788 11.2475 15.1238 11.2475 13.3838 11.4425C13.5713 10.415 13.8113 9.38749 14.1488 8.3975C14.1638 8.3375 14.1563 8.2925 14.1638 8.2325C14.7563 8.09 15.3638 8 16.0013 8C16.6313 8 17.2463 8.09 17.8313 8.2325C17.8388 8.2925 17.8388 8.3375 17.8538 8.3975C18.1913 9.39499 18.4312 10.415 18.6187 11.4425Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
    <path
      d="M11.9425 18.1178C10.9075 17.9303 9.88749 17.6903 8.8975 17.3528C8.8375 17.3378 8.7925 17.3453 8.7325 17.3378C8.59 16.7453 8.5 16.1378 8.5 15.5003C8.5 14.8703 8.59 14.2553 8.7325 13.6703C8.7925 13.6628 8.8375 13.6628 8.8975 13.6478C9.89499 13.3178 10.9075 13.0703 11.9425 12.8828C11.755 14.6228 11.755 16.3778 11.9425 18.1178Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
    <path
      d="M23.5001 15.5003C23.5001 16.1378 23.4101 16.7453 23.2676 17.3378C23.2076 17.3453 23.1626 17.3378 23.1026 17.3528C22.1051 17.6828 21.0851 17.9303 20.0576 18.1178C20.2526 16.3778 20.2526 14.6228 20.0576 12.8828C21.0851 13.0703 22.1126 13.3103 23.1026 13.6478C23.1626 13.6628 23.2076 13.6703 23.2676 13.6703C23.4101 14.2628 23.5001 14.8703 23.5001 15.5003Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
    <path
      d="M18.6187 19.5586C18.4312 20.5936 18.1913 21.6136 17.8538 22.6036C17.8388 22.6636 17.8388 22.7086 17.8313 22.7686C17.2463 22.9111 16.6313 23.0011 16.0013 23.0011C15.3638 23.0011 14.7563 22.9111 14.1638 22.7686C14.1563 22.7086 14.1638 22.6636 14.1488 22.6036C13.8188 21.6061 13.5713 20.5936 13.3838 19.5586C14.2538 19.6561 15.1238 19.7236 16.0013 19.7236C16.8788 19.7236 17.7563 19.6561 18.6187 19.5586Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
    <path
      d="M18.8225 18.3225C16.9466 18.5591 15.0533 18.5591 13.1775 18.3225C12.9408 16.4466 12.9408 14.5533 13.1775 12.6775C15.0533 12.4408 16.9466 12.4408 18.8225 12.6775C19.0591 14.5533 19.0591 16.4466 18.8225 18.3225Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
  </svg>
)

export default withDefaultStyles(FillGlobeWithBg)
